module.exports = __webpack_public_path__ + "static/media/content-3.2c4772e6.svg";